module.exports = __webpack_public_path__ + "img/survivor.0ce1919e.png";